<template>
    <div class="AlbumEdit">
        <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
            <el-form-item label="标题">
                <el-input v-model="formLabelAlign.bt"></el-input>
            </el-form-item>
            <el-form-item label="显示顺序">
                <el-input v-model="formLabelAlign.xssx"></el-input>
            </el-form-item>
            <el-form-item label="外链地址">
                <el-input v-model="formLabelAlign.wldz"></el-input>
            </el-form-item>
            <span>正文内容</span>
            <el-form-item class="zwnr">
                <UEditor :config="myConfig" ref="ueditor" :defaultMsg="defaultMsg"></UEditor>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">立即创建</el-button>
                <el-button>取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import UEditor from '../../components/ueditor/ueditor.vue'
    import {mapActions} from "vuex";
    export default {
        name: 'xwedit2',
        components: {UEditor},
        data () {
            return {
                defaultMsg: '',
                labelPosition: 'right',
                formLabelAlign: {
                    bt: '',
                    xssx: '',
                    wldz:''
                },
                cxlx:this.$route.query.cxlx==null?5:this.$route.query.cxlx,
                ruleForm:{
                    nr:''
                },
                myConfig: {
                    // 如果需要上传功能,找后端小伙伴要服务器接口地址
                    serverUrl: this.$config.baseUrl + 'ueditor/ueditorConfig',
                    // 你的UEditor资源存放的路径,相对于打包后的index.html
                    UEDITOR_HOME_URL: '/ueditor/',
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 工具栏是否可以浮动
                    autoFloatEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: 340,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    // 关闭自动保存
                    enableAutoSave: true
                },
                content: ''
            }
        },
        methods: {
            ...mapActions([
                'zcxwSave',
            ]),
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            onSubmit() {
                this.zcxwSave({_module:'TT',_method:'zcxwSave',"bt": this.formLabelAlign.bt,wldz:this.formLabelAlign.wldz,"xssx": this.formLabelAlign.xssx,nr:this.getContent(),wbnr:this.getContentTxt(),cxlx:this.cxlx}).then((res) => {  //这是从本地请求的数据接口，
                    if(res._result.type=="success"){
                        this.$message('保存成功');
                    }else{
                        this.$message(res._result.content);
                    }
                })
            },
            getContent: function(){
                let content = this.$refs.ueditor.getUEContent();
                return content;
            },
            /*获取纯文本*/
            getContentTxt: function(){
                let content = this.$refs.ueditor.getContentTxt();
                return content;
            },
        }
    }
</script>

<style>
    .zwnr .el-form-item__content{
        margin-left:0px !important;
        line-height: 0;
    }
</style>